/** Each search owns a worker and a document snapshot. Cancel terminates the
 * search; a result is only committed by the caller while that task is current. */
import { workerTask } from './workerTask.js';
export function startPlan(doc, config, onProgress) {
  const worker = new Worker(new URL('./planner.worker.js', import.meta.url), { type: 'module' });
  return workerTask(worker, { doc, config }, onProgress);
}
